var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2879 1.86572L11.2879 1.86569C12.7698 0.382548 15.3589 0.382504 16.8422 1.86572C17.5832 2.60673 17.9915 3.5921 17.9915 4.64218C17.9915 5.69224 17.5832 6.67761 16.8408 7.41998L6.29489 17.9659H0.740625V12.4116L11.2879 1.86572ZM5.22483 15.4812H5.26625L15.0134 3.69312L15.0841 3.62241C15.0841 3.6224 15.0841 3.62238 15.0841 3.62236C14.5376 3.076 13.5897 3.07588 13.0445 3.62251L3.25466 13.411L3.22537 13.4403V13.4817V15.3812V15.4812H3.32537H5.22483Z",
    fill: "#8F8F8F",
    stroke: "#FBFBFB",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIco);
export default __webpack_public_path__ + "static/media/editIco.e95458344f31d3298cd45c65a74e2c88.svg";
export { ForwardRef as ReactComponent };